

(function () {
  'use strict';

  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function initColumns() {
    $$('[data-cerus-footer-col]').forEach(function (col) {
      var trigger = col.querySelector('[data-cerus-footer-col-toggle]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {

        if (!window.matchMedia('(max-width: 749px)').matches) return;
        var open = col.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initNewsletter() {
    var root = document.querySelector('[data-cerus-newsletter]');
    if (!root) return;
    var form = root.querySelector('form');
    var feedback = root.querySelector('[data-cerus-newsletter-feedback]');
    var emailInput = root.querySelector('[data-cerus-newsletter-email]');
    var submitBtn = root.querySelector('.cerus-footer__newsletter-submit');
    if (!form || !emailInput) return;

    function setFeedback(msg, kind) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.hidden = false;
      feedback.classList.remove('is-success', 'is-error');
      if (kind) feedback.classList.add(kind);
    }

    form.addEventListener('submit', function (e) {

      if (!window.fetch) return;
      e.preventDefault();

      var data = new FormData(form);
      if (submitBtn) submitBtn.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (res.ok || res.status === 302 || res.status === 200) {
            setFeedback(form.dataset.successMessage || 'You’re in. Welcome to the inner circle.', 'is-success');
            form.reset();
            try {
              document.dispatchEvent(new CustomEvent('cerus:newsletter-subscribed', {
                detail: { email: data.get('contact[email]') }
              }));
            } catch (err) {  }
          } else {
            setFeedback('Hmm — that didn’t go through. Try again in a moment.', 'is-error');
          }
        })
        .catch(function () {
          setFeedback('Network error. Please try again.', 'is-error');
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initColumns();
      initNewsletter();
    });
  } else {
    initColumns();
    initNewsletter();
  }
})();
